import r from "./_cb.js";
import e from "./_getLength.js";
function t(t) {
  return function (n, o, f) {
    o = r(o, f);
    for (var i = e(n), u = t > 0 ? 0 : i - 1; u >= 0 && u < i; u += t) if (o(n[u], u, n)) return u;
    return -1;
  };
}
export { t as default };